import { makeStyles } from "@mui/styles";
import { colors } from "../../styles/colors";

export default makeStyles({
  checkboxContainer: {
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
  },
  checkbox: {
    color: colors.primary,
    '&.Mui-checked': {
      color: colors.primary,
    },
    '&.Mui-indeterminate': {
      color: colors.primary,
    },
  },
  label: {
    fontSize: "14px",
    marginLeft: "8px",
    color: colors.darkblack,
  }
});